import React, { useCallback, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles, Theme } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useSelector, useDispatch } from "react-redux";
import TimerIcon from "@material-ui/icons/Timer";
import useMedia from "use-media";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Box from "@material-ui/core/Box";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";

import {
  fetchAsyncCreateRecord,
  selectSelectedMenu,
  editRecord,
  selectEditedRecord,
  selectSelectTargetDay,
  fetchAsyncGetTargetMenu,
  selectSelectedUser,
  fetchAsyncGetFavoriteMenu,
  selectDayRecords,
  selectTempRecords,
  fetchAsyncGetMenu,
  fetchAsyncDeleteRecord,
  fetchAsyncDeleteTempRecord,
  fetchAsyncCreateTimeRecord,
  selectTimeRecord,
  fetchAsyncDeleteTimeRecord,
  fetchAsyncUpdateTimeRecord,
  fetchAsyncGetOriginalMenu,
  selectTempOriginalRecords,
  fetchAsyncDeleteTempOriginalRecord,
  fetchAsyncCreateOriginalRecord,
  selectTargetMenu,
  selecDayOriginalRecords,
  fetchAsyncDeleteOriginalRecord,
  selectSelectedMenuCategory,
  selectMenu,
  selectFavoriteMenu,
} from "../home/homeSlice";

import {
  ORIGINAL_RECORD,
  READ_RECORD,
  SELECT_MENU_CATEGORY,
} from "../../types/types";
import { selectLoginUser } from "../auth/authSlice";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: "flex",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(2, 2),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    maxWidth: "66.667%",
    height: 68,
  },
  paperRes: {
    display: "flex",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(2, 2),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    height: 68,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: "#fff",
    padding: theme.spacing(2, 2),
    boxSizing: "border-box",
  },

  color: {
    color: "#2699FB",
  },
  submit: {
    backgroundColor: "#2699FB",
  },
  lastTimeBtn: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#6699cc",
  },
  headerBack: {
    paddingRight: theme.spacing(3),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  record: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    marginBottom: 10,
  },
  addBtn: {
    fontSize: 60,
    color: "#fdd35c",
  },
  addBtnContainer: {
    paddingRight: 0,
  },
  remove: {
    fontSize: 60,
    color: "#ffc184",
    marginRight: 10,
  },
  unit: {
    paddingRight: theme.spacing(1),
  },
  recordItem: {
    width: "50%",
  },
  menuTitle: {
    "& span": {
      fontSize: 10,
    },
  },
  listItem: {
    marginBottom: theme.spacing(0.3),
    backgroundColor: "#F5F5F5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 0,
    paddingLeft: theme.spacing(1),
    paddingTop: 3,
    paddingBottom: 3,
    minHeight: 54,
  },
  tempListItem: {
    marginBottom: theme.spacing(0.3),
    backgroundColor: "#fff3b8",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 0,
    paddingLeft: theme.spacing(1),
    paddingTop: 3,
    paddingBottom: 3,
    minHeight: 54,
    borderRadius: 5,
  },
  listItemSub: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  body: {
    fontSize: 10,
    paddingRight: theme.spacing(1),
  },
  listHeight: {
    overflow: "auto",
    boxSizing: "border-box",
    marginBottom: 50,
  },
  root: {
    borderRadius: "30px",
  },
  listContainer: {
    margin: theme.spacing(0, 1),
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginTop: 70,
    height: "80%",
    overflowX: "scroll",
  },
  backgroundColor: {
    backgroundColor: "#ffffff",
    height: "100vh",
    position: "relative",
  },
  timeInput: {
    width: "80%",
    "& ::placeholder": {
      fontSize: 10,
    },
  },
  addContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text: {
    fontSize: 10,
    marginRight: 30,
  },
  circulContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 3,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    backgroundColor: "rgba(237,238,255,0.5)",
    width: "90%",
    paddingBottom: 100,
    paddingTop: 50,
    borderRadius: 8,
  },
  modalItem: {
    width: "90%",
    margin: "0 auto",
  },
  modalText: {
    textAlign: "center",
    paddingBottom: 30,
    fontWeight: "bold",
    fontSize: 20,
  },
  modalBox: {
    paddingTop: 20,
    display: "flex",
    justifyContent: "space-around",
  },
  modalDeleteBtn: {
    width: 103,
  },
  width: {
    width: "100%",
  },
  listHeader: {
    color: "#555555",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  image: {
    position: "relative",
    height: 200,
    boxShadow: "0 0.3rem 1em rgba(255,255,255,0.4)",
    [theme.breakpoints.down("xs")]: {
      width: "50% !important", // Overrides inline-style
      height: 100,
    },
    "&:hover, &$focusVisible": {
      zIndex: 1,
      "& $imageBackdrop": {
        opacity: 0.15,
      },
      "& $imageMarked": {
        opacity: 0,
      },
      "& $imageButton": {
        border: "4px solid currentColor",
      },
    },
  },
  imageMyMenu: {
    position: "relative",
    height: 200,
    boxShadow: "0 0.3rem 1em rgba(255,255,255,0.4)",
    [theme.breakpoints.down("xs")]: {
      width: "100% !important", // Overrides inline-style
      height: 100,
    },
    "&:hover, &$focusVisible": {
      zIndex: 1,
      "& $imageBackdrop": {
        opacity: 0.15,
      },
      "& $imageMarked": {
        opacity: 0,
      },
      "& $imageTitle": {
        border: "4px solid currentColor",
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center 45%",
  },
  imageBackdrop: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create("opacity"),
  },
  imageTitle: {
    position: "relative",
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${
      theme.spacing(1) + 6
    }px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.white,
    position: "absolute",
    bottom: -2,
    left: "calc(50% - 9px)",
    transition: theme.transitions.create("opacity"),
  },
  titleFont: {
    fontWeight: "bold",
    fontSize: 20,
  },
  titleFontSub: {
    fontWeight: "bold",
    fontSize: 15,
  },
}));

const RecordBoard: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const timeText = "(削除する場合は空欄で登録)";
  const selectedMenu = useSelector(selectSelectedMenu);
  const editedRecord = useSelector(selectEditedRecord);
  const targetDay = useSelector(selectSelectTargetDay);
  const menu = useSelector(selectMenu);
  const favoriteMenu = useSelector(selectFavoriteMenu);
  const tempRecords = useSelector(selectTempRecords);
  const loginUser = useSelector(selectLoginUser);
  const timeRecord = useSelector(selectTimeRecord);
  const dayRecords = useSelector(selectDayRecords);
  const tempOriginalRecords = useSelector(selectTempOriginalRecords);
  const dayOriginalRecords = useSelector(selecDayOriginalRecords);
  const selectedMenuCategory = useSelector(selectSelectedMenuCategory);
  const [isLoading, setIsLoading] = useState(false);
  //選択日付格納用
  const selectedUser = useSelector(selectSelectedUser);
  const isWide = useMedia({ minWidth: "600px" });
  const [open, setOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({
    id: 0,
    title: "",
    text: "",
  });
  const [originalOpen, setOriginalOpen] = useState(false);
  const [deleteOriginalTarget, setDeleteOriginalTarget] = useState({
    id: 0,
    title: "",
    text: "",
  });
  const [tempOpen, setTempOpen] = useState(false);
  const [deleteTempTarget, setDeleteTempTarget] = useState({
    id: 0,
    title: "",
    text: "",
  });
  const [tempOriginalOpen, setTempOriginalOpen] = useState(false);
  const [deleteTempOriginalTarget, setDeleteTempOriginalTarget] = useState({
    id: 0,
    title: "",
    text: "",
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [time, setTime] = useState(
    timeRecord.id !== 0 ? timeRecord.time_number : 0
  );

  //レコード追加画面へ
  const addRecord = async () => {
    await setIsLoading(true);
    // await dispatch(fetchAsyncGetMenu());
    await dispatch(fetchAsyncGetFavoriteMenu());
    await dispatch(fetchAsyncGetOriginalMenu());
    await history.push("/home/menu/category");
    await setIsLoading(false);
  };

  const handleSelectCategory = useCallback(
    async (category: SELECT_MENU_CATEGORY) => {
      await setIsLoading(true);
      menu.length === 0 && (await dispatch(fetchAsyncGetMenu(category.part)));
      favoriteMenu.length === 0 &&
        (await dispatch(fetchAsyncGetFavoriteMenu()));
      await history.push("/home/menu/list");
      await setIsLoading(false);
    },
    [dispatch]
  );

  //modal用
  const handleDeleteModal = async (record: READ_RECORD) => {
    const weight = record.weight ? `${record.weight}kg` : "";
    const rep = record.number_value ? `${record.number_value}rep` : "";
    const set = record.set_value ? `${record.set_value}set` : "";
    const subText = `${weight} ${rep} ${set}`;
    await setDeleteTarget({
      id: record.id,
      title: record.menu_title,
      text: subText,
    });
    await setOpen(true);
  };
  const handleDeleteOriginalModal = async (record: ORIGINAL_RECORD) => {
    const weight = record.weight ? `${record.weight}kg` : "";
    const rep =
      record.number_value &&
      record.menu_type !== "time" &&
      record.menu_type !== "km"
        ? `${record.number_value}rep`
        : "";
    const min = record.menu_type === "time" ? `${record.number_value}min` : "";
    const set = record.set_value ? `${record.set_value}set` : "";
    const km = record.menu_type === "km" ? `${record.number_value}km` : "";
    const subText = `${weight} ${rep} ${min} ${km} ${set}`;
    await setDeleteOriginalTarget({
      id: record.id,
      title: record.menu_title,
      text: subText,
    });
    await setOriginalOpen(true);
  };
  const handleDeleteTempModal = async (record: READ_RECORD) => {
    const weight = record.weight ? `${record.weight}kg` : "";
    const rep = record.number_value ? `${record.number_value}rep` : "";
    const set = record.set_value ? `${record.set_value}set` : "";
    const subText = `${weight} ${rep} ${set}`;
    await setDeleteTempTarget({
      id: record.id,
      title: record.menu_title,
      text: subText,
    });
    await setTempOpen(true);
  };
  const handleDeleteTempOriginalModal = async (record: ORIGINAL_RECORD) => {
    const weight = record.weight ? `${record.weight}kg` : "";
    const rep =
      record.number_value &&
      record.menu_type !== "time" &&
      record.menu_type !== "km"
        ? `${record.number_value}rep`
        : "";
    const min = record.menu_type === "time" ? `${record.number_value}min` : "";
    const set = record.set_value ? `${record.set_value}set` : "";
    const km = record.menu_type === "km" ? `${record.number_value}km` : "";
    const subText = `${weight} ${rep} ${min} ${km} ${set}`;
    await setDeleteTempOriginalTarget({
      id: record.id,
      title: record.menu_title,
      text: subText,
    });
    await setTempOriginalOpen(true);
  };
  const handleClose = () => {
    setDeleteTarget({ id: 0, title: "", text: "" });
    setOpen(false);
  };
  const handleOriginalClose = () => {
    setDeleteOriginalTarget({ id: 0, title: "", text: "" });
    setOriginalOpen(false);
  };
  const handleTempClose = () => {
    setDeleteTempTarget({ id: 0, title: "", text: "" });
    setTempOpen(false);
  };
  const handleTempOriginalClose = () => {
    setDeleteTempOriginalTarget({ id: 0, title: "", text: "" });
    setTempOriginalOpen(false);
  };
  //modalの削除ボタン押下時
  const handleDeleteRecord = async () => {
    await dispatch(fetchAsyncDeleteRecord(deleteTarget.id));
    await setOpen(false);
    await setDeleteTarget({ id: 0, title: "", text: "" });
  };
  const handleDeleteOriginalRecord = async () => {
    await dispatch(fetchAsyncDeleteOriginalRecord(deleteOriginalTarget.id));
    await setOriginalOpen(false);
    await setDeleteOriginalTarget({ id: 0, title: "", text: "" });
  };
  //modalの削除押下時　temp削除
  const handleDeleteTempRecord = async () => {
    await dispatch(fetchAsyncDeleteTempRecord(deleteTempTarget.id));
    await setTempOpen(false);
    await setDeleteTempTarget({ id: 0, title: "", text: "" });
  };
  //modalの削除押下時　オリジナルメニューのtemp削除
  const handleDeleteTempOriginalRecord = async () => {
    await dispatch(
      fetchAsyncDeleteTempOriginalRecord(deleteTempOriginalTarget.id)
    );
    await setTempOriginalOpen(false);
    await setDeleteTempOriginalTarget({ id: 0, title: "", text: "" });
  };

  //画面遷移
  const backProfile = useCallback(() => {
    history.push("/home");
  }, [history]);

  //登録押下時、tempのレコードを本登録し、tempを削除
  const handleCreateRecord = async (e: React.FormEvent<HTMLFormElement>) => {
    await e.preventDefault();
    //timeのレコードが存在せず、timeが入力されている場合
    if (time !== 0 && timeRecord.id === 0) {
      const para = {
        date: targetDay,
        time_number: time,
      };
      await dispatch(fetchAsyncCreateTimeRecord(para));
    }
    //すでにtimeが登録されているが、今回の入力値が０の場合
    if (time === 0 && timeRecord.id !== 0) {
      const para = {
        id: timeRecord.id,
        date: targetDay,
        user_id: loginUser.id,
      };
      await dispatch(fetchAsyncDeleteTimeRecord(para));
    }
    //timeが入力されており、すでに存在するtimeと異なる場合
    if (time > 0 && timeRecord.id !== 0 && time !== timeRecord.time_number) {
      const para = {
        id: timeRecord.id,
        date: targetDay,
        user_id: timeRecord.user_id,
        time_number: time,
      };
      await dispatch(fetchAsyncUpdateTimeRecord(para));
    }
    await tempRecords.map(async (record) => {
      await dispatch(fetchAsyncCreateRecord(record));
      await dispatch(fetchAsyncDeleteTempRecord(record.id));
    });
    await tempOriginalRecords.map(async (record) => {
      await dispatch(fetchAsyncCreateOriginalRecord(record));
      await dispatch(fetchAsyncDeleteTempOriginalRecord(record.id));
    });
    await history.push("/home");
  };

  //time入力
  //保存されているtime_numberと異なる場合、登録ボタンを表示
  const handleInputTime = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setTime(Number(e.target.value));
    },
    [timeRecord]
  );
  useEffect(() => {
    time || setIsSubmit(false);
    time !== timeRecord.time_number && setIsSubmit(true);
    time === timeRecord.time_number && setIsSubmit(false);
  }, [time]);

  //editRecordへ対象のレコードを追加して、createRecordページへ遷移する
  const handleEditRecord = async (record: READ_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(fetchAsyncGetTargetMenu(record.menu_id));
    await history.push("/home/create/record");
  };
  //オリジナルメニューの場合
  const handleEditOriginalRecord = async (record: ORIGINAL_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(
      selectTargetMenu({
        id: record.menu_id,
        title: record.menu_title,
        part: record.menu_part_number,
        part_name: record.menu_part,
        type: record.menu_type_number,
        type_name: record.menu_type,
        color: record.menu_color_number,
        menu_color: record.menu_color,
        user_id: Number(record.menu_user_id),
      })
    );
    await history.push("/home/create/record");
  };
  const handleEditTempRecord = async (record: READ_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(fetchAsyncGetTargetMenu(record.menu_id));
    await history.push("/home/add/record");
  };
  //オリジナルメニューレコードの編集
  const handleEditTempOriginalRecord = async (record: ORIGINAL_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(
      selectTargetMenu({
        id: record.menu_id,
        title: record.menu_title,
        part: record.menu_part_number,
        part_name: record.menu_part,
        type: record.menu_type_number,
        type_name: record.menu_type,
        color: record.menu_color_number,
        menu_color: record.menu_color,
        user_id: Number(record.menu_user_id),
      })
    );
    await history.push("/home/add/record");
  };

  //新規作成時に、レコードのmenuとdateを格納する
  //既存のレコード編集時には処理しない
  useEffect(() => {
    if (editedRecord.length > 0 && editedRecord[0].id === 0) {
      dispatch(
        editRecord([
          {
            id: 0,
            menu_id: selectedMenu.id,
            weight: null,
            number_value: 0,
            set_value: null,
            date: targetDay,
          },
        ])
      );
    }
    // timeRecord.id !== 0 && setTime(timeRecord.time_number);
  }, [dispatch, timeRecord]);

  useEffect(() => {
    loginUser.id === 0 && history.push("/home");
  }, [history]);

  return (
    <form onSubmit={handleCreateRecord}>
      <Grid container>
        <Grid
          item
          xs={12}
          className={classes.backgroundColor}
          component={Paper}
          elevation={6}
          square
        >
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <div className={classes.modalContainer}>
                <div className={classes.modalText}>削除しますか？</div>
                <div className={classes.modalItem}>
                  <ListItem
                    key={deleteTarget.id}
                    button
                    className={classes.listItem}
                  >
                    <div>
                      <ListItemText
                        primary={deleteTarget.title}
                        className={classes.menuTitle}
                      />
                    </div>

                    <div className={classes.listItemSub}>
                      <ListItemText
                        disableTypography
                        primary={deleteTarget.text}
                        className={classes.body}
                      />
                    </div>
                  </ListItem>
                </div>
                <div className={classes.modalBox}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.modalDeleteBtn}
                    onClick={handleDeleteRecord}
                  >
                    削除
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleClose}
                  >
                    キャンセル
                  </Button>
                </div>
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={originalOpen}
            onClose={handleOriginalClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={originalOpen}>
              <div className={classes.modalContainer}>
                <div className={classes.modalText}>削除しますか？</div>
                <div className={classes.modalItem}>
                  <ListItem
                    key={deleteOriginalTarget.id}
                    button
                    className={classes.listItem}
                  >
                    <div>
                      <ListItemText
                        primary={deleteOriginalTarget.title}
                        className={classes.menuTitle}
                      />
                    </div>

                    <div className={classes.listItemSub}>
                      <ListItemText
                        disableTypography
                        primary={deleteOriginalTarget.text}
                        className={classes.body}
                      />
                    </div>
                  </ListItem>
                </div>
                <div className={classes.modalBox}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.modalDeleteBtn}
                    onClick={handleDeleteOriginalRecord}
                  >
                    削除
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleOriginalClose}
                  >
                    キャンセル
                  </Button>
                </div>
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={tempOpen}
            onClose={handleTempClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={tempOpen}>
              <div className={classes.modalContainer}>
                <div className={classes.modalText}>削除しますか？</div>
                <div className={classes.modalItem}>
                  <ListItem
                    key={deleteTempTarget.id}
                    button
                    className={classes.listItem}
                  >
                    <div>
                      <ListItemText
                        primary={deleteTempTarget.title}
                        className={classes.menuTitle}
                      />
                    </div>

                    <div className={classes.listItemSub}>
                      <ListItemText
                        disableTypography
                        primary={deleteTempTarget.text}
                        className={classes.body}
                      />
                    </div>
                  </ListItem>
                </div>
                <div className={classes.modalBox}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.modalDeleteBtn}
                    onClick={handleDeleteTempRecord}
                  >
                    削除
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleTempClose}
                  >
                    キャンセル
                  </Button>
                </div>
              </div>
            </Fade>
          </Modal>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={tempOriginalOpen}
            onClose={handleTempOriginalClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={tempOriginalOpen}>
              <div className={classes.modalContainer}>
                <div className={classes.modalText}>削除しますか？</div>
                <div className={classes.modalItem}>
                  <ListItem
                    key={`original-${deleteTempOriginalTarget.id}`}
                    button
                    className={classes.listItem}
                  >
                    <div>
                      <ListItemText
                        primary={deleteTempOriginalTarget.title}
                        className={classes.menuTitle}
                      />
                    </div>

                    <div className={classes.listItemSub}>
                      <ListItemText
                        disableTypography
                        primary={deleteTempOriginalTarget.text}
                        className={classes.body}
                      />
                    </div>
                  </ListItem>
                </div>
                <div className={classes.modalBox}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.modalDeleteBtn}
                    onClick={handleDeleteTempOriginalRecord}
                  >
                    削除
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    onClick={handleTempOriginalClose}
                  >
                    キャンセル
                  </Button>
                </div>
              </div>
            </Fade>
          </Modal>
          {isLoading && (
            <div className={classes.circulContainer}>
              <CircularProgress />
            </div>
          )}
          <div className={isWide ? classes.paper : classes.paperRes}>
            <div className={classes.width}>
              <div className={classes.header}>
                <div className={classes.headerBack}>
                  <ArrowBackIcon onClick={backProfile} />
                </div>
                {((tempRecords.length > 0 && tempRecords[0]?.id !== 0) ||
                  isSubmit ||
                  (tempOriginalRecords.length > 0 &&
                    tempOriginalRecords[0]?.id !== 0)) && (
                  <Box alignItems="center" display="flex">
                    <div className={classes.text}>
                      登録タップでカレンダーに反映
                    </div>
                    <div>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                      >
                        登録
                      </Button>
                    </div>
                  </Box>
                )}
              </div>
            </div>
          </div>
          <div className={classes.listContainer}>
            <div className={classes.addContainer}>
              <TextField
                margin="normal"
                id="weight"
                label={`時間　${timeRecord.id !== 0 ? timeText : ""}`}
                name="number_value"
                type="number"
                className={classes.timeInput}
                placeholder="任意でトレーニング時間の記録が可能"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TimerIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end" className={classes.unit}>
                      Min
                    </InputAdornment>
                  ),
                  inputProps: { min: 0, max: 400 },
                }}
                onChange={handleInputTime}
                value={time === 0 ? undefined : time}
              />
              <IconButton className={classes.addBtnContainer}>
                <AddToPhotosIcon
                  className={classes.addBtn}
                  onClick={addRecord}
                />
              </IconButton>
            </div>
            {selectedMenuCategory.title.length > 0 && (
              <ButtonBase
                focusRipple
                className={classes.imageMyMenu}
                focusVisibleClassName={classes.focusVisible}
                style={{
                  width: selectedMenuCategory.width,
                }}
                onClick={() => handleSelectCategory(selectedMenuCategory)}
              >
                <span
                  className={classes.imageSrc}
                  style={{
                    backgroundImage: `url(${selectedMenuCategory.url})`,
                  }}
                />
                <span className={classes.imageBackdrop} />
                <span className={classes.imageButton}>
                  <Typography
                    component="span"
                    variant="subtitle1"
                    color="inherit"
                    className={classes.imageTitle}
                  >
                    <span className={classes.titleFontSub}>続けて登録する</span>
                    <br />
                    <span className={classes.titleFont}>
                      {selectedMenuCategory.title}
                    </span>
                    {}
                  </Typography>
                </span>
              </ButtonBase>
            )}

            <List dense>
              {(tempRecords.length > 0 && tempRecords[0]?.id !== 0) ||
              (tempOriginalRecords.length > 0 &&
                tempOriginalRecords[0]?.id !== 0) ? (
                <div className={classes.listHeader}>
                  <CalendarTodayIcon />
                  カレンダー未反映の記録
                </div>
              ) : (
                ""
              )}
              {tempRecords[0]?.id !== 0 &&
                tempRecords.map((record, index) => {
                  const labelId = `label ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value && record.menu_part !== "有"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${min} ${km} ${set}`;

                  return (
                    <ListItem
                      key={record.id}
                      button
                      className={classes.tempListItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          <EditIcon
                            onClick={() => handleEditTempRecord(record)}
                          />
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() => handleDeleteTempModal(record)}
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
              {tempOriginalRecords[0]?.id !== 0 &&
                tempOriginalRecords.map((record, index) => {
                  const labelId = `original-label- ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value &&
                    record.menu_type !== "time" &&
                    record.menu_type !== "km"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${min} ${km} ${set}`;

                  return (
                    <ListItem
                      key={`original-${record.id}`}
                      button
                      className={classes.tempListItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          <EditIcon
                            onClick={() => handleEditTempOriginalRecord(record)}
                          />
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() =>
                                handleDeleteTempOriginalModal(record)
                              }
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
            </List>
            <List dense>
              {(dayRecords.length > 0 && dayRecords[0]?.id !== 0) ||
              (dayOriginalRecords.length > 0 &&
                dayOriginalRecords[0]?.id !== 0) ? (
                <div className={classes.listHeader}>
                  <EventAvailableIcon />
                  カレンダー反映済みの記録
                </div>
              ) : (
                ""
              )}
              {dayRecords.length > 0 &&
                dayRecords[0]?.id !== 0 &&
                dayRecords.map((record, index) => {
                  const labelId = `label ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value && record.menu_part !== "有"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${min} ${km} ${set}`;

                  return (
                    <ListItem
                      key={record.id}
                      button
                      className={classes.listItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          <EditIcon onClick={() => handleEditRecord(record)} />
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() => handleDeleteModal(record)}
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
              {dayOriginalRecords.length > 0 &&
                dayOriginalRecords[0]?.id !== 0 &&
                dayOriginalRecords.map((record, index) => {
                  const labelId = `label-original ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value &&
                    record.menu_type !== "time" &&
                    record.menu_type !== "km"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${min} ${km} ${set}`;

                  return (
                    <ListItem
                      key={`original-${record.id}`}
                      button
                      className={classes.listItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          <EditIcon
                            onClick={() => handleEditOriginalRecord(record)}
                          />
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() => handleDeleteOriginalModal(record)}
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
            </List>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};

export default RecordBoard;
